"use client";

import {
  selectTopEducation,
  type CandidateEducationInput,
} from "@/features/candidate/lib/education";
import { EducationLogo, EmptyCell } from "@/features/candidate";
import type { PipelineCandidate } from "@/lib/api/types";
import { titleCasePreserveAcronyms } from "@/lib/string/title-case";

export function EducationCell({ candidate }: { candidate: PipelineCandidate }) {
  const edu = selectTopEducation(
    candidate.education as CandidateEducationInput[] | undefined,
  );
  const raw = edu?.schoolName;
  if (!raw) {
    return <EmptyCell />;
  }
  return (
    <div className="flex min-w-0 items-center gap-1.5">
      <EducationLogo domain={edu?.schoolDomain} name={raw} />
      <span className="truncate whitespace-nowrap text-sm text-muted-foreground">
        {titleCasePreserveAcronyms(raw)}
      </span>
    </div>
  );
}
